import Vue from 'vue'
import VueRouter from 'vue-router'
import { routers } from './router'
import config from '@/utils/config'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routers
})

// 路由判断登录 根据路由配置文件的参数
router.beforeEach((to, from, next) => {
  console.log('from:', from, to)

  const isTest = Vue.prototype.$isTestEnvironment()
  // const base = isTest ? "https://test.ascod.cn" : "https://api.ascod.cn";
  // Vue.prototype.$base = base;
  const base = window.location.origin

  if (base.indexOf('bxjs') > -1) {
    document.title = '宝秀科技'
  } else if (base.indexOf('irrigate') > -1) {
    document.title = '智感科技'
  } else if (base.indexOf('map.ascod.cn') > -1) {
    document.title = 'MAP物联'
  } else {
    document.title = '菱云物联'
  }

  Vue.prototype.$base = base

  if (!window.sse) {
    Vue.prototype.$openSSE()
    console.log(window.sse)
  }

  // 调试
  // console.log(redirecturls);
  // console.log("-");
  // console.log(isredirecturls);
  // console.log("-");
  // console.log(to.name);
  // console.log("-");
  // console.log(isLogin);
  // console.log("-");
  // console.log(isBindTel);
  // return;

  // 需要路由记忆的页面---------------------------------------------------------
  const memoryRoute = [
    'live',
    'member',
    'changepwd',
    'trend',
    'export',
    'valva',
    'tasklist'
  ]
  if (memoryRoute.indexOf(to.name) >= 0) {
    // 路由记忆
    localStorage.setItem('retrunpath', to.path)
  } else {
    localStorage.removeItem('retrunpath')
  }
  const redirecturls = localStorage.getItem('retrunpath')
  const isredirecturls = !!localStorage.getItem('retrunpath')

  // 是否需要路由权限过滤,不需要路由过滤的直接进入跳转页面---------------------------------------
  if (!to.matched.some(record => record.meta.requireAuth)) {
    console.log('no auth next', to)
    // router.push({ name: to.name })
    next()
    return
  }

  // 获取当前的登录状态-------------------------------------------------------------------
  let isLogin = false
  const isBindTel = false
  const ua = navigator.userAgent.toLowerCase()
  const isWechat = ua.match(/MicroMessenger/i)
    ? ua.match(/MicroMessenger/i)[0] === 'micromessenger'
    : false

  if (localStorage.getItem('token')) {
    isLogin = true
  }

  // 走微信登录
  // 免登录页面 不进入微信登录逻辑
  if (!isLogin && isWechat && to.name !== 'view') {
    let snsapi = localStorage.getItem('snsapi')
    if (!snsapi) {
      snsapi = 'snsapi_base'
    }
    console.log('snsapi--', snsapi)
    let state = {}
    if (snsapi === 'snsapi_base') {
      state = JSON.stringify({
        type: 1
      })
    } else if (snsapi === 'snsapi_userinfo') {
      state = JSON.stringify({
        type: 2
      })
    }
    const redirectUri = base + '/wx-login'
    console.log('state', state)
    console.log('redirect_uri', redirectUri)
    const toUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${config.getAppId()}&redirect_uri=${redirectUri}&response_type=code&scope=${snsapi}&state=${encodeURIComponent(
      state
    )}#wechat_redirect`
    console.log('url', toUrl)
    window.location.href = toUrl
    return
  }
  // 自助检测【不】需要验证登录权限跳转的url集合-----------------------------------------------------------------
  const nextRoute = ['login', 'h5Device', 'tokenExpire', 'view']
  console.log('next', to)
  if (!(nextRoute.indexOf(to.name) >= 0)) {
    if (!isLogin) {
      console.log('路由到未登录')
      // 未登录的路由
      router.push({ name: 'login' })
      return
    }
  }

  // 当路由到登录页面的时候------------------------------------
  const orBindTelRoute = ['login']
  if (orBindTelRoute.indexOf(to.name) >= 0) {
    if (isLogin) {
      // 登录了并绑定了手机
      // 有路由记忆
      if (isredirecturls) {
        router.push(redirecturls)
        return
      } else {
        // 没有路由记忆
        router.push({
          name: 'live'
        })
        return
      }
    }
  }
  next()
})
export default router
